export const uk = {
    campaign: 'Кампания',
    name: 'Название',
    status: 'Статус',
    type: 'Тип'
};
